// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"717e5dc8","258":"f0f92604","337":"8702f5ac","453":"acf33c34","583":"0025cd8f","859":"6f3f5de1"}[chunkId] + ".chunk.js";
};